var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-steps',{attrs:{"active":_vm.step,"align-center":""}},[_c('el-step',{attrs:{"title":_vm.$t('ppwc.p3')}}),_c('el-step',{attrs:{"title":_vm.$t('ppwc.p4')}}),_c('el-step',{attrs:{"title":_vm.$t('ppwc.p5')}}),_c('el-step',{attrs:{"title":_vm.$t('ppwc.p6')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }